import SectionTitleReveal from '../common/section-title-reveal';

new SectionTitleReveal();
